import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {TourDisabledModus} from './tour-disabled-modus.model';
import {TourDisabledModusActions, TourDisabledModusActionTypes} from './tour-disabled-modus.actions';
import {createSelector} from '@ngrx/store';

export interface State extends EntityState<TourDisabledModus> {
  // additional entities state properties
}

export const adapter: EntityAdapter<TourDisabledModus> = createEntityAdapter<TourDisabledModus>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(
  state = initialState,
  action: TourDisabledModusActions
): State {
  switch (action.type) {
    case TourDisabledModusActionTypes.AddTourDisabledModus: {
      return adapter.addOne(action.payload.tourDisabledModus, state);
    }

    case TourDisabledModusActionTypes.UpsertTourDisabledModus: {
      return adapter.upsertOne(action.payload.tourDisabledModus, state);
    }

    case TourDisabledModusActionTypes.AddTourDisabledModuss: {
      return adapter.addMany(action.payload.tourDisabledModuss, state);
    }

    case TourDisabledModusActionTypes.UpsertTourDisabledModuss: {
      return adapter.upsertMany(action.payload.tourDisabledModuss, state);
    }

    case TourDisabledModusActionTypes.UpdateTourDisabledModus: {
      return adapter.updateOne(action.payload.tourDisabledModus, state);
    }

    case TourDisabledModusActionTypes.UpdateTourDisabledModuss: {
      return adapter.updateMany(action.payload.tourDisabledModuss, state);
    }

    case TourDisabledModusActionTypes.DeleteTourDisabledModus: {
      return adapter.removeOne(action.payload.id, state);
    }

    case TourDisabledModusActionTypes.DeleteTourDisabledModuss: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case TourDisabledModusActionTypes.LoadTourDisabledModuss: {
      return adapter.addAll(action.payload.tourDisabledModuss, state);
    }

    case TourDisabledModusActionTypes.ClearTourDisabledModuss: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const selectFeature = (state): EntityState<TourDisabledModus> => state.root.tourDisabledModus;

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors(selectFeature);

export const selectById = (id: string) => createSelector(
  selectEntities,
  (entities) => entities[id]
);

export const selectTourDisabledModus = createSelector(selectAll, tourDisabledModus => tourDisabledModus);
